import { getRoutes } from "@/utils/helpers";
import { NavLink } from "react-router-dom";

const HeaderBottom: React.FC = () => {
  const routes = getRoutes();

  return (
    <div className="flex justify-center px-4">
      <ul className="flex items-center gap-6 font-inter h-16">
        <li>
          <NavLink
            to={routes.dashboard}
            className={({ isActive }) =>
              `${isActive ? "text-secondary" : "text-primary"}`
            }
          >
            Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink
            to={routes.brands}
            end
            className={({ isActive }) =>
              `${isActive ? "text-secondary" : "text-primary"}`
            }
          >
            Brands
          </NavLink>
        </li>
        <li>
          <NavLink
            to={routes.invoices}
            className={({ isActive }) =>
              `${isActive ? "text-secondary" : "text-primary"}`
            }
          >
            Payout reports
          </NavLink>
        </li>
        <li>
          <NavLink
            to={routes.orders}
            className={({ isActive }) =>
              `${isActive ? "text-secondary" : "text-primary"}`
            }
          >
            Orders
          </NavLink>
        </li>
        <li>
          <NavLink
            to={routes.products}
            className={({ isActive }) =>
              `${isActive ? "text-secondary" : "text-primary"}`
            }
          >
            Products
          </NavLink>
        </li>
        <li>
          <NavLink
            to={routes.inventory}
            end
            className={({ isActive }) =>
              `${isActive ? "text-secondary" : "text-primary"}`
            }
          >
            Inventory
          </NavLink>
        </li>
        <li>
          <NavLink
            to={routes.analytics}
            className={({ isActive }) =>
              `${isActive ? "text-secondary" : "text-primary"}`
            }
          >
            Analytics
          </NavLink>
        </li>
        <li>
          <NavLink
            to={routes.campaigns}
            className={({ isActive }) =>
              `${isActive ? "text-secondary" : "text-primary"}`
            }
          >
            Campaigns
          </NavLink>
        </li>
        <li>
          <NavLink
            to={routes.vendor}
            className={({ isActive }) =>
              `${isActive ? "text-secondary" : "text-primary"}`
            }
          >
            Settings
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default HeaderBottom;
